const Images = {
  heroBg: require("./front-pages/backgrounds/hero-bg.png"),
  heroDashboard: require("./front-pages/landing-page/hero-dashboard-light.png"),
  heroDashboardDark: require("./front-pages/landing-page/hero-dashboard-dark.png"),
  joinCommunityArrow: require("./front-pages/icons/Join-community-arrow.png"),
  heroElement: require("./front-pages/landing-page/hero-elements-light.png"),
  heroElementDark: require("./front-pages/landing-page/hero-elements-dark.png"),
  sectionTitleIcon: require("./front-pages/icons/section-title-icon.png"),
  lightLogo1: require("./front-pages/branding/logo_1-light.png"),
  lightLogo2: require("./front-pages/branding/logo_2-light.png"),
  lightLogo3: require("./front-pages/branding/logo_3-light.png"),
  lightLogo4: require("./front-pages/branding/logo_4-light.png"),
  lightLogo5: require("./front-pages/branding/logo_5-light.png"),
  clientLogo1: require("./front-pages/branding/logo-1.png"),
  clientLogo2: require("./front-pages/branding/logo-2.png"),
  clientLogo3: require("./front-pages/branding/logo-3.png"),
  clientLogo4: require("./front-pages/branding/logo-4.png"),
  clientLogo5: require("./front-pages/branding/logo-5.png"),
  clientLogo6: require("./front-pages/branding/logo-6.png"),
  teamMember1: require("./front-pages/landing-page/team-member-1.png"),
  teamMember2: require("./front-pages/landing-page/team-member-2.png"),
  teamMember3: require("./front-pages/landing-page/team-member-3.png"),
  teamMember4: require("./front-pages/landing-page/team-member-4.png"),
  pricingPlansArrow: require("./front-pages/icons/pricing-plans-arrow.png"),
  basicPlanIcon: require("./front-pages/icons/paper-airplane.png"),
  standardPlanIcon: require("./front-pages/icons/plane.png"),
  PremiumPlanIcon: require("./front-pages/icons/shuttle-rocket.png"),
  avatar1: require("./avatars/1.png"),
  avatar2: require("./avatars/2.png"),
  avatar3: require("./avatars/3.png"),
  avatar4: require("./avatars/4.png"),
  avatar5: require("./avatars/5.png"),
  faqBoyImage: require("./front-pages/landing-page/faq-boy-with-logos.png"),
  ctaLightBg: require("./front-pages/backgrounds/cta-bg-light.png"),
  ctaDarkBg: require("./front-pages/landing-page/cta-bg-dark.png"),
  ctaDashboardBg: require("./front-pages/landing-page/cta-dashboard.png"),
  contactBorder: require("./front-pages/icons/contact-border.png"),
  contactCustomerService: require("./front-pages/landing-page/contact-customer-service.png"),
  footerBg: require("./front-pages/backgrounds/footer-bg.png"),
  appleIcon: require("./front-pages/landing-page/apple-icon.png"),
  googleIcon: require("./front-pages/landing-page/google-play-icon.png"),
  navItemCol: require("./front-pages/misc/nav-item-col-img.png"),
  WHO: require("./front-pages/branding/who-world-health-organization-seeklogo.png"),
  UNICEF: require("./front-pages/branding/unicef-seeklogo.png"),
  CDC: require("./front-pages/branding/cdc-seeklogo.png"),
  Gavi: require("./front-pages/branding/gavi-seeklogo.png"),
  manWithLap: require("./illustrations/man-with-laptop-light.png"),
  boyWithStatis: require("./illustrations/boy-with-statistic.png"),
  chartSuccess: require("./icons/unicons/chart-success.png"),
  walletInfo: require("./icons/unicons/wallet-info.png"),
  paypal: require("./icons/unicons/paypal.png"),
  ccPrimary: require("./icons/unicons/cc-primary.png"),
  wallet: require("./icons/unicons/wallet.png"),
  childCare: require("./front-pages/landing-page/child_care.png"),
  faq: require("./front-pages/landing-page/faq.png"),
  ladyDoc: require("./front-pages/landing-page/ladyDoc.png"),
  manDoc1: require("./front-pages/landing-page/manDoc.png"),
  manDoc2: require("./front-pages/landing-page/manDoc2.png"),
  manDoc3: require("./front-pages/landing-page/manDoc3.png"),
  landingHeroLight: require("./front-pages/landing-page/landing-image.png"),
  landingHeroDark: require("./front-pages/landing-page/landing_image_black.png"),
};

export default Images;
